<template>
  <v-app
    :style="
      $store.state.query.view == 'SendMessage'
        ? 'background-color: #c4261b'
        : ''
    "
  >
    <v-main class="change-font">
      <router-view></router-view>
    </v-main>
  </v-app>
</template>

<script>
export default {
  name: "App",

  components: {},

  data: () => ({
    //
  }),
};
</script>

<style lang="scss">
@import "@/assets/scss/style.scss";
@import "~vuetify/src/styles/styles.sass";

$body-font-family: "noto_sans_thairegular", "Noto Sans", sans-serif, Helvetica;
$heading-font-family: "noto_sans_thairegular", "Noto Sans", sans-serif,
  Helvetica;
.swal2-popup {
  font-family: "noto_sans_thairegular", "Noto Sans", sans-serif, Helvetica !important;
}
.myfont {
  font-family: "noto_sans_thairegular", "Noto Sans", sans-serif, Helvetica !important;
}
.v-application {
  .change-font {
    h1,
    h2,
    h3,
    h4,
    h5,
    h6,
    .title,
    .headline,
    .subtitle_1 {
      font-family: "noto_sans_thairegular", "Noto Sans", sans-serif, Helvetica !important;
    }
    font-family: "noto_sans_thairegular", "Noto Sans", sans-serif, Helvetica !important;
  }
}
</style>
